export default "<p>\n  field works!\n</p>\n"